import { Card, CardBody, CardHeader } from '@nextui-org/react'
import { FC } from 'react'
import '../../../styles/responsive.css'
import { CardNameLiteral } from '../../../types/apiResponse/tankInfoSettingTypes'
import { makeTitle } from '../../../utils/tankInfo'
import { NoContent } from './NoContent'

export type DistProps = {
  tankId: string
  cardName: CardNameLiteral
}

export const DistCard: FC<DistProps> = ({ tankId, cardName }) => {
  const { title, subTitle } = makeTitle(cardName)

  // Distribution data is not available from /tank/{id} API
  return (
    <Card
      className="rounded-lg col-span-1 border border-tdpldarkgrey/60 bg-tdplbisque
        w-full md:w-auto h-[140px] md:h-[140px] p-4 md:p-[19px] pb-[9px] md:pb-[9px]"
      style={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }}
    >
      <CardHeader className="flex flex-row items-start m-0 p-0">
        <p className="text-tdpldarkgrey text-[1rem] font-bold">{title}</p>
        {subTitle !== undefined ? (
          <p className="text-tdplmiddlegrey text-[1rem]">{subTitle}</p>
        ) : null}
      </CardHeader>
      <CardBody className="m-0 p-0 h-[99px] md:h-auto md:h-[65px] overflow-visible">
        <div className="flex items-center justify-center w-full h-full md:h-full">
          <NoContent />
        </div>
      </CardBody>
    </Card>
  )
}
